import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Variables } from 'src/app/Models/variables';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsPovService implements CanActivate {

  constructor() { }

  canActivate() {
    const v = new Variables();
    const p = localStorage.getItem('ups');
    if (p == null) {
      return false;
    }
    const val = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
    const perm = JSON.parse(val);
    if (perm.includes('NTM.Analytics.PerformanceOverview')
        || perm.includes('NTM.Administration.Full')) {
          return true;
    } else {
      return false;
    }
  }
}
